module.exports = __webpack_public_path__ + "img/5.39f5c130.png";